import { NotificationChannelOption } from './subscription-dialog.models';

export const STATUS_PAGE_SUBSCRIPTION_CHANNEL_OPTIONS: NotificationChannelOption[] = [
  { id: 'email', label: 'Email', icon: 'mail', formControlName: 'email', subscriberType: 1 },
  { id: 'slack', label: 'Slack', icon: 'tag', formControlName: 'slack', subscriberType: 4 },
  { id: 'sms', label: 'SMS', icon: 'chat_bubble_outline', formControlName: 'sms', subscriberType: 2 },
  { id: 'msTeams', label: 'MS Teams', icon: 'groups', formControlName: 'msTeams', subscriberType: 5 },
  { id: 'webhook', label: 'Webhook', icon: 'link', formControlName: 'webhook', subscriberType: 3 }
];

export const STATUS_PAGE_INTERNAL_SUPPORTED_CONTACT_METHOD_NAMES = {
  email: 'email-official',
  sms: 'sms-official'
} as const;
